
<template>
  <a :href="params ? `${to}?${params}` : to" @click="linkTo">
    <slot />
  </a>
</template>

<script>
import md5 from 'js-md5'
const specRoutesNames = [
  // 'order_details',
  // 'manual_order_creation',
  // 'order_inspection',
  // 'order_weighting',
  // 'pull_1688_orders',
  // 'external_storage_goods',
  // 'inventory_init'
]

export default {
  props: {
    to: {
      type: String,
      required: true
    },
    params: {
      type: String,
      default: ''
    }
  },
  methods: {
    getNowFormatDate() {
      const date = new Date()
      const seperator1 = '-'
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      return year + seperator1 + month + seperator1 + strDate
    },
    linkTo(e) {
      e.preventDefault()
      let newTab = false
      const { to, params } = this
      if (to === '/service_support/guset_service') {
        const currentDate = this.getNowFormatDate()
        const sellerAccount = this.$store.state.user.shopName
        const versionName = 'KJERP1.0'
        const signString = sellerAccount + versionName + currentDate + 'zsxjwdt'
        const checkString = versionName + sellerAccount + currentDate + 'qwertZXCVB'
        const sign = md5(md5(signString))
        const check = md5(md5(checkString))
        const url = 'https://haitunapi.wangdian.cn/customer_service/login?'
        const resUrl = url + 'seller_account=' + sellerAccount + '&version_name=' + versionName + '&sign=' + sign + '&check=' + check
        window.open(resUrl)
      } else {
        if (specRoutesNames.includes(this.$route.name)) {
          newTab = true
        } else {
          // const parentRoute = this.$route.path.split('/')[1]
          // const route = to.split('/')[1]
          // newTab = parentRoute !== route
        }
        const linkUrl = params ? `${to}?${params}` : to
        if (this.$utils.isExternal(linkUrl)) {
          location.href = linkUrl
        } else if (newTab) {
          window.open(linkUrl)
        } else {
          this.$router.push(linkUrl)
        }
      }
    }
  }
}
</script>
